import { render, staticRenderFns } from "./vip-company-choose.vue?vue&type=template&id=44b765ba&scoped=true"
import script from "./vip-company-choose.vue?vue&type=script&lang=js"
export * from "./vip-company-choose.vue?vue&type=script&lang=js"
import style0 from "./vip-company-choose.vue?vue&type=style&index=0&id=44b765ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b765ba",
  null
  
)

export default component.exports